import { useState, useEffect } from 'react';
import { db } from '../firebase';
import { doc, onSnapshot, setDoc, getDoc } from 'firebase/firestore';

export default function useTeamScores() {
    const [teamScores, setTeamScores] = useState({ blackWhite: 0, redWhite: 0 });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const today = new Date().toDateString();
        setLoading(true);

        // First fetch data synchronously
        const fetchInitialData = async () => {
            try {
                const docRef = doc(db, 'dailyScores', today);
                const docSnap = await getDoc(docRef);

                if (docSnap.exists()) {
                    setTeamScores(docSnap.data());
                } else {
                    // Create document if it doesn't exist
                    const initialScores = { blackWhite: 0, redWhite: 0 };
                    await setDoc(docRef, initialScores);
                    setTeamScores(initialScores);
                }
                setLoading(false);
            } catch (error) {
                console.error("Error fetching team scores:", error);
                setLoading(false);
            }
        };

        fetchInitialData();

        // Then set up real-time listener
        const unsubscribe = onSnapshot(doc(db, 'dailyScores', today), (doc) => {
            if (doc.exists()) {
                setTeamScores(doc.data());
                setLoading(false);
            }
        });

        return unsubscribe;
    }, []);

    return { teamScores, loading };
}